import { Observable } from 'rxjs';
import { finalize, shareReplay } from 'rxjs/operators';

/**
 * Collapses concurrent calls for the same request into one HTTP call.
 *
 * Several components on one page often ask for the same thing at the same
 * moment (the homepage asks for interests, user details and the plate count
 * from more than one place). While a request is in flight, every caller
 * shares it; once it settles the next call goes to the network again, so
 * nothing is cached beyond the request itself.
 */
export class InFlight<T> {
  private pending: Observable<T> | null = null;

  public get(make: () => Observable<T>): Observable<T> {
    if (!this.pending) {
      this.pending = make().pipe(
        finalize(() => (this.pending = null)),
        shareReplay({ bufferSize: 1, refCount: false })
      );
    }
    return this.pending;
  }
}
